module.exports = __webpack_public_path__ + "img/12_windAndRain_xxh.cf0994e6.png";